// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1e058","type":"styles_type__1uwlA","choices":"styles_choices__sUqcT"};